function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useRef, useContext, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, DropdownListContainer, DropdownList, KEYBOARD_KEYS } from '@keen.io/ui-core';
import { useKeypress } from '@keen.io/react-hooks';
import { Container, DropableContainer, DropdownContainer, WarningMessage, DefaultLabel, ItemContainer } from './PropertyTypeCast.styles';
import FiltersContext from '../../FiltersContext';
import { createOptions } from './utils';
import { DATA_TYPES } from './constants';
import { SCHEMA_PROPS } from '../../../../constants';

var PropertyTypeCast = function PropertyTypeCast(_ref) {
  var type = _ref.type,
      property = _ref.property,
      onChange = _ref.onChange;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      editMode = _useState2[0],
      setEditMode = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectionIndex = _useState4[0],
      setIndex = _useState4[1];

  var containerRef = useRef(null);

  var _useContext = useContext(FiltersContext),
      schema = _useContext.schema;

  var items = createOptions(DATA_TYPES);
  useEffect(function () {
    if (editMode) {
      var index = items.findIndex(function (_ref2) {
        var value = _ref2.value;
        return value === type;
      });
      setIndex(index);
    }

    return function () {
      return setIndex(null);
    };
  }, [editMode]);
  var outsideClick = useCallback(function (e) {
    if (editMode && containerRef.current && !containerRef.current.contains(e.target)) {
      setEditMode(false);
    }
  }, [editMode, containerRef]);
  useEffect(function () {
    document.addEventListener('click', outsideClick);
    return function () {
      return document.removeEventListener('click', outsideClick);
    };
  }, [editMode, containerRef]);
  var schemaType = property ? SCHEMA_PROPS[schema[property]] : null;
  var keyboardHandler = useCallback(function (_e, keyCode) {
    switch (keyCode) {
      case KEYBOARD_KEYS.ENTER:
        var value = items[selectionIndex].value;
        onChange(value);
        setEditMode(false);
        break;

      case KEYBOARD_KEYS.UP:
        if (selectionIndex > 0) {
          setIndex(selectionIndex - 1);
        }

        break;

      case KEYBOARD_KEYS.DOWN:
        if (selectionIndex === null) {
          setIndex(0);
        } else if (selectionIndex < items.length - 1) {
          setIndex(selectionIndex + 1);
        }

        break;

      case KEYBOARD_KEYS.ESCAPE:
        setEditMode(false);
        break;
    }
  }, [items]);
  useKeypress({
    keyboardAction: keyboardHandler,
    handledKeys: [KEYBOARD_KEYS.ENTER, KEYBOARD_KEYS.ESCAPE, KEYBOARD_KEYS.UP, KEYBOARD_KEYS.DOWN],
    addEventListenerCondition: editMode,
    eventListenerDependencies: [editMode]
  });
  return React.createElement(Container, {
    "data-testid": "property-type-cast",
    ref: containerRef,
    onClick: function onClick(e) {
      e.stopPropagation();
      !editMode && setEditMode(true);
    },
    onKeyDown: function onKeyDown(e) {
      e.stopPropagation();
      e.keyCode === KEYBOARD_KEYS.ENTER && !editMode && setEditMode(true);
    },
    role: "button",
    tabIndex: 0
  }, React.createElement(DropableContainer, {
    editMode: editMode,
    isActive: schemaType !== type
  }, type), React.createElement(Dropdown, {
    isOpen: editMode,
    fullWidth: false
  }, React.createElement(DropdownContainer, null, React.createElement(WarningMessage, null, t('query_creator_property_type_cast.cast_message')), React.createElement(DropdownListContainer, {
    scrollToActive: true,
    maxHeight: 240
  }, function (activeItemRef) {
    return React.createElement(DropdownList, {
      ref: activeItemRef,
      items: createOptions(DATA_TYPES),
      renderItem: function renderItem(_ref3) {
        var label = _ref3.label,
            value = _ref3.value;
        return React.createElement(ItemContainer, null, React.createElement("span", null, label), ' ', value === schemaType && React.createElement(DefaultLabel, null, t('query_creator_property_type_cast.default_label')));
      },
      setActiveItem: function setActiveItem(_ref4) {
        var value = _ref4.value;
        return items[selectionIndex] && value === items[selectionIndex].value;
      },
      onClick: function onClick(_e, _ref5) {
        var value = _ref5.value;
        setEditMode(false);
        onChange(value);
      }
    });
  }))));
};

export default PropertyTypeCast;